jQuery( function( $ ) {

	const $start = $( '#start_date' );
	const $end = $( '#end_date' );
	const defaultDates = [];
	if ( $start.val() && $end.val() ) {
		defaultDates.push( $start.val() );
		defaultDates.push( $end.val() );
	}

	if ( $( '.date-range' ).length ) {
		$( '.date-range' ).flatpickr( {
			mode: 'range',
			minDate: 'today',
			dateFormat: 'd/m/Y',
			defaultDate: defaultDates,
			onChange: function( selectedDates ) {

				if ( 2 === selectedDates.length ) {
					const startDate = selectedDates[0].toLocaleDateString(
						'en-GB', {
							day: 'numeric',
							month: 'numeric',
							year: 'numeric',
						} ).split( ' ' ).join( '/' );
					const endDate = selectedDates[1].toLocaleDateString( 'en-GB',
						{
							day: 'numeric',
							month: 'numeric',
							year: 'numeric',
						},
					).split( ' ' ).join( '/' );
					$start.val( startDate );
					$end.val( endDate );
				}
				else {
					$start.val( '' );
					$end.val( '' );
				}

			},
		} );
	}

	$( '#venue' ).on( 'change', function() {
		const $subvenue = $( '#subvenue' );
		if ( '' === $( this ).val() ) {
			$subvenue.prop( 'disabled', true );
		}
		else {
			$subvenue.removeProp( 'disabled' );
		}
	} );

	$( 'button.clear' ).click( function() {
		$( this ).closest( 'form' ).find( 'select, input' ).each( function() {
			$( this ).val( '' );
		} );
		$( '#subvenue' ).prop( 'disabled', true );
	} );
} );
